export default {
    version: '10016',
    language: 'de',

    sessionToken: null,

    companyId: null,
    userId: null,
    userGroupId: null,
    userIdent: null,
    isMobile: false,
    startPath: null,

    rememberMe: false,

    dashboardReportId: null,

    menu: null,

    host: document.location.origin.includes('localhost') ? 'http://sms2/' : document.location.origin.includes('sms-mobile.') ? 'https://sms-mobile.mo-worxx.de/' : 'https://sms-portal.mo-worxx.de/',
    portalHost: document.location.origin.includes('localhost') ? 'http://sms2/' : document.location.origin.includes('sms-mobile.') ? 'https://sms-portal.mo-worxx.de/' : 'https://sms-portal.mo-worxx.de/',
    apiHost: document.location.origin.includes('localhost') ? 'http://sms2/api/' : document.location.origin.includes('sms-mobile.') ? 'https://sms-mobile.mo-worxx.de/api/' : 'https://sms-portal.mo-worxx.de/api/',
};
